"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLastFileFeedItems = exports.setIsFetching = exports.setFirstFeedItem = exports.setFeedItems = exports.setFeedItemProgression = exports.setFeedItemIsEndReached = exports.setFeedFiles = exports.resetFeedItemProgression = exports.requestPostFeedItem = exports.requestPostFeedFile = exports.requestPatchFeedItem = exports.requestGetFeedItems = exports.requestGetFeedItemFiles = exports.requestDeleteLocalFeedItems = exports.requestDeleteFeedItem = exports.removeReplayableFeedItemFailed = exports.removeFeedItems = exports.patchLocalFeedItem = exports.addReplayableFeedItemFailed = exports.addFeedItems = exports.addFeedFiles = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var addFeedFiles = (_feedItems, _feed) => ({
  type: types.ADD_FEED_FILES,
  _feedItems,
  _feed
});
exports.addFeedFiles = addFeedFiles;
var addFeedItems = (_feedItems, _feed) => ({
  type: types.ADD_FEED_ITEMS,
  _feedItems,
  _feed
});
exports.addFeedItems = addFeedItems;
var addReplayableFeedItemFailed = feedItem => ({
  type: types.ADD_REPLAYABLE_FEED_ITEM_FAILED,
  feedItem
});
exports.addReplayableFeedItemFailed = addReplayableFeedItemFailed;
var patchLocalFeedItem = (_feedItem, payload) => ({
  type: types.PATCH_LOCAL_FEED_ITEM,
  _feedItem,
  payload
});
exports.patchLocalFeedItem = patchLocalFeedItem;
var removeFeedItems = _feedItems => ({
  type: types.REMOVE_FEED_ITEMS,
  _feedItems
});
exports.removeFeedItems = removeFeedItems;
var removeReplayableFeedItemFailed = _feedItem => ({
  type: types.REMOVE_REPLAYABLE_FEED_ITEM_FAILED,
  _feedItem
});
exports.removeReplayableFeedItemFailed = removeReplayableFeedItemFailed;
var requestDeleteFeedItem = (_feed, _feedItem) => ({
  type: types.REQUEST_DELETE_FEED_ITEM,
  _feed,
  _feedItem
});
exports.requestDeleteFeedItem = requestDeleteFeedItem;
var requestDeleteLocalFeedItems = _feedItems => ({
  type: types.REQUEST_DELETE_LOCAL_FEED_ITEMS,
  _feedItems
});
exports.requestDeleteLocalFeedItems = requestDeleteLocalFeedItems;
var requestGetFeedItemFiles = exports.requestGetFeedItemFiles = function requestGetFeedItemFiles(_feed) {
  var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: types.REQUEST_GET_FEED_FILES,
    _feed,
    reset
  };
};
var requestGetFeedItems = exports.requestGetFeedItems = function requestGetFeedItems(_feed) {
  var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: types.REQUEST_GET_FEED_ITEMS,
    _feed,
    reset
  };
};
var requestPatchFeedItem = (_feed, feedItem) => ({
  type: types.REQUEST_PATCH_FEED_ITEM,
  feedItem,
  _feed
});
exports.requestPatchFeedItem = requestPatchFeedItem;
var requestPostFeedFile = exports.requestPostFeedFile = function requestPostFeedFile(file, filename, _feed, fileType, content) {
  var fileSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  return {
    type: types.REQUEST_POST_FEED_FILE,
    file,
    filename,
    _feed,
    fileType,
    content,
    fileSize
  };
};
var requestPostFeedItem = feedItem => ({
  type: types.REQUEST_POST_FEED_ITEM,
  feedItem
});
exports.requestPostFeedItem = requestPostFeedItem;
var resetFeedItemProgression = (_feed, _feedItem) => ({
  type: types.RESET_FEED_ITEM_UPLOAD_PROGRESSION,
  _feedItem,
  _feed
});
exports.resetFeedItemProgression = resetFeedItemProgression;
var setFeedFiles = (_feedItems, _feed) => ({
  type: types.SET_FEED_FILES,
  _feedItems,
  _feed
});
exports.setFeedFiles = setFeedFiles;
var setFeedItemIsEndReached = (_feed, isEndReached) => ({
  type: types.SET_FEED_ITEM_IS_END_REACHED,
  isEndReached,
  _feed
});
exports.setFeedItemIsEndReached = setFeedItemIsEndReached;
var setFeedItemProgression = (_feed, _feedItem, loaded, total) => ({
  type: types.SET_FEED_ITEM_UPLOAD_PROGRESSION,
  loaded,
  total,
  _feedItem,
  _feed
});
exports.setFeedItemProgression = setFeedItemProgression;
var setFeedItems = (_feedItems, _feed) => ({
  type: types.SET_FEED_ITEMS,
  _feedItems,
  _feed
});
exports.setFeedItems = setFeedItems;
var setFirstFeedItem = (_feed, _feedItem) => ({
  type: types.SET_FIRST_FEED_ITEM,
  _feed,
  _feedItem
});
exports.setFirstFeedItem = setFirstFeedItem;
var setIsFetching = (_feed, isFetching) => ({
  type: types.SET_IS_FETCHING_FEED_ITEM,
  isFetching,
  _feed
});
exports.setIsFetching = setIsFetching;
var setLastFileFeedItems = _items => ({
  type: types.SET_LAST_FILE_FEED_ITEMS,
  _items
});
exports.setLastFileFeedItems = setLastFileFeedItems;